export default {
  job: {
    required: true,
    type: Object
  }
}
